import { cn } from '~/lib/common-utils'

export function TitleSection({
  title,
  subtitle,
  className,
}: {
  title?: string
  subtitle?: string
  className?: string
}) {
  if (!title && !subtitle) return null

  return (
    <div className={cn('flex flex-col gap-2 text-center', className)}>
      {title && (
        <h2 className="text-center font-lora text-xl font-medium leading-7 text-secondary-950 md:text-4xl">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="mx-auto max-w-3xl text-center font-lexend text-sm font-light leading-5 text-secondary-950 md:text-base">
          {subtitle}
        </p>
      )}
    </div>
  )
}
